import Component from "./components"

declare global {
    interface Window {
        Components: Component
    }
}

window.Components = new Component()